import React from 'react';
import FingerprintCapture from '../SubComponents/FingerprintCapture';
import FingerprintsTable from '../SubComponents/FingerprintsTable';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import FingerprintStepApp from './../Functionality/FingerprintStepApp';
import CustomCard from '../../../../../components/CustomCard';
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */

const FingerprintStep = (props) => {
    const {
        t,
        capturing,
        setCapturing,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintSrc,
        setFingerprintSrc,
        updatedFinger,
        setFingerprintName,
        setSelectedReader,
        fingerprintsList,
        setUpdated,
        setModified,
        fingerprintName,
        userData,
        handleUploadFinger,
        setEmptyFields,
        handleRemoveAllFingerprints,
        fingerprintsTemp,
        setFingerprintsTemp,
        mergedFingerprints,
        emptyFields,
    } = props;

    const {
        isAllCheckedFingerprints,
        selectFingerprintsForDelete,
        deleteFingerprintsShow,
        setDeleteFingerprintShow,
        handleCaptureFinger,
        fingerprintStatus,
        handleCancel,
        handleClearFingerprint,
    } = FingerprintStepApp({
        t,
        capturing,
        setCapturing,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintSrc,
        setFingerprintSrc,
        updatedFinger,
        setFingerprintName,
        setSelectedReader,
        fingerprintsList,
        setUpdated,
        setModified,
        userData,
        handleRemoveAllFingerprints,
        fingerprintsTemp,
        setFingerprintsTemp,
    });

    return (
        <div className='row'>
            <div className='d-flex justify-content-end mb-4 pr-0'>
                {!userData?.id && (
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_fs_clean_finger'
                        Icon={CleanIcon}
                        title={'clean_fingerprint'}
                        onClick={(e) => {
                            handleClearFingerprint(e);
                        }}
                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                    />
                )}
            </div>
            <div className='border-radius-8px border-full-shades-300 p-3'>
                <div className='row'>
                    <div className='col-sm-12 col-md-4 pl-0 pr-2 d-flex flex-column'>
                        <div className='w-100 flex-grow-1 d-flex flex-column'>
                            <FingerprintCapture
                                t={t}
                                capturing={capturing}
                                capturedFingerprint={capturedFingerprint}
                                handleCaptureFinger={handleCaptureFinger}
                                fingerprintStatus={fingerprintStatus}
                                handleCancel={handleCancel}
                                fingerprintName={fingerprintName}
                                setFingerprintName={setFingerprintName}
                                handleUploadFinger={handleUploadFinger}
                                setEmptyFields={setEmptyFields}
                                handleClearFingerprint={handleClearFingerprint}
                                userData={userData}
                                emptyFields={emptyFields}
                            />
                        </div>
                    </div>

                    <div className='col-sm-12 col-md-8 pl-2 pr-0 d-flex flex-column'>
                        <div className='w-100 flex-grow-1 d-flex flex-column'>
                            <FingerprintsTable
                                t={t}
                                setUpdated={setUpdated}
                                fingerprintsTemp={fingerprintsTemp}
                                setFingerprintsTemp={setFingerprintsTemp}
                                userData={userData}
                                fingerprintsList={fingerprintsList}
                                mergedFingerprints={mergedFingerprints}
                                isAllChecked={isAllCheckedFingerprints}
                                selectedList={selectFingerprintsForDelete}
                                deleteFingerprintShow={deleteFingerprintsShow}
                                setDeleteFingerprintShow={setDeleteFingerprintShow}
                                handleDeleteAll={handleRemoveAllFingerprints}
                                handleRemoveAllFingerprints={handleRemoveAllFingerprints}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FingerprintStep;
